/** Operacja na opcji wyjazdu (`OptionChangeOp`). */
export enum OptionChangeOp {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  CHANGE = 'CHANGE',
}

/** Operacja na wariancie transportu (`TransportChangeOp`); `CLEAR` ⇒ `newVariantId === null`. */
export enum TransportChangeOp {
  SET = 'SET',
  CHANGE = 'CHANGE',
  CLEAR = 'CLEAR',
}

/** Operacja na ubezpieczeniu uczestnika (`InsuranceChangeOp`). */
export enum InsuranceChangeOp {
  SET = 'SET',
  CHANGE = 'CHANGE',
  CLEAR = 'CLEAR',
}
